import { navLinks } from "../constants";

const MobileBottomNav = () => {
  return (
    <nav className="fixed bottom-0 left-0 w-full bg-black/90 border-t border-white/10 backdrop-blur-md z-50 flex py-3 md:hidden">
    {navLinks.map(({ link, name, iconPath }) => (
        <a
        key={name}
        href={link}
        className="flex-1 flex flex-col items-center justify-center text-white text-sm hover:text-blue-300 transition-colors"
        >
        <img src={iconPath} alt={name} className="w-8 h-auto mb-1" />
        <span className="text-[10px]">{name}</span>
        </a>
    ))}
    </nav>
  );
};

export default MobileBottomNav;
